export default __webpack_public_path__ + "static/media/kids-coloring-energy-image.8f06c193.jpg";